import type {
	IndicatorComparisonPayload,
	IndicatorPeriodPayload,
} from '@Application/Indicators/Actions/indicatorPeriodPayload';

export type DocumentIndicatorsPayload = {
	queryKey: string;
	period: IndicatorPeriodPayload;
	generated: IndicatorComparisonPayload;
	byType: Array<{ readonly documentType: { readonly id: number }; readonly count: number }>;
};

export type DocumentIndicatorsFetchedAction = {
	type: 'DOCUMENT_INDICATORS_FETCHED';
	payload: DocumentIndicatorsPayload;
};

export default (payload: DocumentIndicatorsPayload): DocumentIndicatorsFetchedAction => ({
	type: 'DOCUMENT_INDICATORS_FETCHED',
	payload,
});
